import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });

    // Notify Google Analytics (GA4) of SPA route change
    if (typeof window.gtag === "function") {
      window.gtag("config", "G-H5LSWP7H2L", {
        page_path: pathname + (search || ""),
      });
    }
  }, [pathname, search]);

  return null;
}
